import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useCompiledRules } from '../hooks/useDqs';
import { RulesTable } from '../components/RulesTable';

export function RegelinzichtPage() {
  const { t } = useTranslation();
  const { data, isLoading, error } = useCompiledRules();
  const kopRef = useRef<HTMLHeadingElement>(null);

  const rules = data?.data || [];

  return (
    <div data-testid="regelinzicht-page">
      <div className="mb-5">
        <h1
          ref={kopRef}
          tabIndex={-1}
          style={{
            fontSize: '1.25rem',
            fontWeight: 700,
            letterSpacing: '-0.02em',
            color: 'var(--foreground-heading)',
          }}
        >
          {t('dqs.title')}
        </h1>
        <p
          className="mt-[3px]"
          style={{ fontSize: '0.8125rem', color: 'var(--foreground-muted)' }}
        >
          {t('dqs.subtitle')}
        </p>
      </div>

      {isLoading && (
        <div
          className="flex items-center justify-center py-16"
          data-testid="regelinzicht-loading"
        >
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--border)] border-t-[var(--primary)]" />
        </div>
      )}

      {error && (
        <div
          className="rounded-xl p-8 text-center text-[0.8125rem]"
          style={{ backgroundColor: 'var(--background)', color: 'var(--foreground-muted)' }}
          data-testid="regelinzicht-error"
        >
          {t('dqs.unavailable')}
        </div>
      )}

      {data && rules.length === 0 && (
        <div
          className="rounded-xl p-8 text-center text-[0.8125rem]"
          style={{ backgroundColor: 'var(--background)', color: 'var(--foreground-muted)' }}
          data-testid="regelinzicht-empty"
        >
          {t('dqs.empty')}
        </div>
      )}

      {data && rules.length > 0 && <RulesTable kopRef={kopRef} rules={rules} />}
    </div>
  );
}
